module.exports = __webpack_public_path__ + "static/img/pan_head_img.bc568fc.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/pan_head_img.svg
// module id = cbSx
// module chunks = 3